<style scoped>

  .menu-parent-container {
    width: 100%;
    height: 40px;
    overflow: hidden !important;
  }

  .menu-child-container {
    height: 100%;
    margin-bottom: -50px;
    overflow-y: hidden !important;
    overflow-x: scroll !important;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
  }
  .menu-child-container::-webkit-scrollbar {
    display: none;
  }
  .menu-child-container::-moz-scrollbar {
    display: none;
  }

  @media only screen and (min-width: 1001px) {
    .ui.pointing.secondary.menu {
      width: 100% !important;
    }
  }

  @media only screen and (max-width: 1000px) {
    .ui.pointing.secondary.menu {
      width: 1045px !important;
    }
  }

</style>

<template>

  <div>

    <div id="horizontal-tabs-parent-menu" class="menu-parent-container">
      <div id="horizontal-tabs-child-menu" class="menu-child-container">
        <div class="ui pointing secondary menu">
          <a v-if="tabs" v-for="tab in tabs" class="item" :class="{ active: activeTab == tab.id }" 
            @click="onSelectTab(tab.id)">        
            {{ tab.label }}
          </a>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  export default {

    data() {
      return {
        activeTab: "",
      }
    },

    props: ["tabs"],

    mounted() {

      const isFirefox = (navigator.userAgent.toLowerCase().indexOf("firefox") > -1)

      if (isFirefox) {
        $("#horizontal-tabs-parent-menu").removeClass("menu-parent-container")
        $("#horizontal-tabs-child-menu").removeClass("menu-child-container")
      }

      if (this.tabs && this.tabs.length > 0)
        this.activeTab = this.tabs[0].id
    },

    methods: {

      onSelectTab(id) {

        this.activeTab = id

        this.$emit("onSelectTab", id)
      },      
    },
  }

</script>
